import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../../../components/Modal';
import { ArquivoBase } from '../../../types';

interface IFinishCheckingModal {
  setFinishCheckingModalShow: Dispatch<SetStateAction<boolean>>;
  finishChecking: (baseFiles: ArquivoBase[]) => Promise<void>;
  baseFiles: ArquivoBase[];
  finishCheckingModalShow: boolean;
}

export default function FinishCheckingModal({
  setFinishCheckingModalShow,
  finishChecking,
  baseFiles,
  finishCheckingModalShow,
}: IFinishCheckingModal) {
  return (
    <MyModal
      title={'Finalizar Conferência'}
      closeButtonLabel="Cancelar"
      actionButtonLabel="Finalizar"
      modalBody={(
        <div>
          Tem certeza que deseja finalizar a conferência?
        </div>
      )}
      onClose={() => setFinishCheckingModalShow(false)}
      onAction={() => finishChecking(baseFiles)}
      show={finishCheckingModalShow}
      type="action"
    />
  );
}
